define('views/blocks/checkout/ShopMessageCheckoutDialogView',['views/blocks/checkout/CheckoutDialogView','app','template!blocks/checkout/dialog-shop-message'],
    function (CheckoutDialogView,app,dialogShopMessageTemplate) {

        var checkoutModel;

        return CheckoutDialogView.extend({
            name:'shop-message',
            events:{
                'keyup .input':'onChange',
                'change .input': 'onChange',
                'paste .input':'onChange',
                'click .btn-remove--input':'onClickClear',
            },
            initialize:function(options){
                checkoutModel = options.checkoutModel;
                CheckoutDialogView.prototype.initialize.apply(this, arguments);
                this.onChange();
            },
            getInner:function(){
                return dialogShopMessageTemplate(checkoutModel);
            },
            afterIntro:function(){
                // autofocus
                if(!Modernizr.touchevents){
                    this.$('.input').focus();
                }
            },
            onClickClear:function(){
                this.$('.input').val('');
                this.onChange();
            },

            onChange:function(){
                var view = this;
                view.$('.btn-remove--input').attr('data-value',view.$('.input').val());
                // auto expend text area
                var autoExpendEl = view.$('.auto-expend').get(0);
                setTimeout(function() {
                    autoExpendEl.style.cssText = "height: auto";
                    autoExpendEl.style.cssText = "height: "+(2+autoExpendEl.scrollHeight)+"px";
                }, 0);
            },
            submit:function(){
                var view = this,
                    message = view.$('.input').val().trim();
                    app.getCart().setOrderMessage(message);
                // TODO
                view.close();
                return false;
            }
        });
    });
